import { render, staticRenderFns } from "./Activity4_4Radio.vue?vue&type=template&id=526e2963&"
import script from "./Activity4_4Radio.vue?vue&type=script&lang=js&"
export * from "./Activity4_4Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports